import { toggleCheckedExport } from 'redux/features/favoris/slice'
import {
  makeSelectFavoris,
  makeSelectSelected,
} from 'redux/features/favoris/selectors'
import { useAppDispatch, useAppSelector } from 'redux/hooks'

interface ReturnProps {
  active: boolean
  commentaire: string
  checked: boolean
  toggleChecked: () => void
  selected: boolean
}

/**
 * This hook serves to manage a single favorite
 */
const useFavori = (uid: string): ReturnProps => {
  const favoris = useAppSelector(makeSelectFavoris)
  const selected = useAppSelector(makeSelectSelected)
  const favori = favoris[uid]
  const dispatch = useAppDispatch()

  const toggleChecked = () => dispatch(toggleCheckedExport(uid))

  if (typeof favori === 'undefined') {
    return {
      active: false,
      commentaire: '',
      checked: false,
      toggleChecked,
      selected: false,
    }
  }

  return {
    active: favori.isActive,
    commentaire: favori.commentaire,
    checked: favori.isChecked,
    toggleChecked,
    selected: (selected && selected === uid) || false,
  }
}

export default useFavori
